import React, { useEffect, useState } from "react";
import { CustomButton } from "../../../components/button/CustomButton";
import { ContestsModal } from "../../../components/modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { createContestThunk as onCreateContest } from "../../../slices/contest/thunk";
import { createSelector } from "@reduxjs/toolkit";
import { resetContestThunk as onResetContest } from "../../../slices/contest/thunk";
import { Spinner } from "../../../components/spinner/Spinner";
import { useNavigate } from "react-router-dom";


function CreateContest({description,contestId,purpose,isPremiumUser}) {

  const navigate = useNavigate();
  const dispatch = useDispatch();
 
  const [modalOpen, setModalOpen] = useState(false);
  const [showIsLoader, setShowIsLoader] = useState(false);
  const [isParticipateDone, setIsParticipateDone] = useState(false);
  const [isContestCreated, setIsContestCreated] = useState(false);

  const selectContestState = (state) => state.contest;
  const contestSelector = createSelector(selectContestState, (contest) => ({
    isLoading: contest.isLoading,
    isCreateContest:contest.isCreateContest,
    isParticipate:contest.isParticipate
  }));

  const {isLoading,isCreateContest,isParticipate } = useSelector(contestSelector);
    
    dispatch(onResetContest());

    const handleCreateContest = () => {
    dispatch(onResetContest())
    dispatch(onCreateContest({'contestId': contestId }));

  };

    useEffect(() => {
      setShowIsLoader(isLoading)
        if(isCreateContest){
            setIsContestCreated(true);
          }
    }, [isCreateContest,isLoading]);

    //isContestCreated
        useEffect(() => {
        if(isContestCreated){
           setModalOpen(true);
          }
          setIsContestCreated(false);
    }, [isContestCreated]);

        useEffect(() => {
        setIsParticipateDone(isParticipate)
    }, [isParticipate]);


        useEffect(() => {
        if(isParticipateDone){
       navigate("/artist/contests/140");
          }
    }, [isParticipateDone,navigate]);

  return (
    <>
    
      <div className="w-full flex flex-col items-center justify-start">
        <div className="w-full border border-border_color rounded-[14px] flex flex-col p-2 sm:p-4 items-center">
          <p className="w-full  min-h-[150px] p-3 rounded-xl text-sm">{description}</p>
        </div>
        <div className="w-full flex flex-col sm:flex-row items-center justify-center gap-4 mt-10 sm:mt-24">
          <>
           {isPremiumUser && (
           <button className=" w-full h-[52px]  text-white bg-secondary tracking-wider font-grotesk  text-sm font-bold py-[15px] px-4 rounded-[10px] whitespace-nowrap">
            Write Comment
          </button>
          )}

          <button onClick={() => handleCreateContest()}  disabled={isLoading}  className=" w-full h-[52px]  text-white bg-primary tracking-wider font-grotesk  text-sm font-bold py-[15px] px-4 rounded-[10px] whitespace-nowrap">
            {showIsLoader ? <Spinner /> : "Create Contest"}
          </button>

          {/* <CustomButton 
            onClick={() => handleCreateContest()} 
            text={showIsLoader ? <Spinner /> : "Create Contest"} 
            disabled={isLoading} 
          /> */}
          </>
        </div>
        <ContestsModal
          openModal={modalOpen}
          closeModal={() => setModalOpen(false)}
        />
      </div>

    
    </>
  );
}

export default CreateContest;
